import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { convertFromWei } from 'modules/api/utils';

export interface IGetFlashUnstakeDataResult {
  fee: BigNumber;
  upToAmount: BigNumber;
}

export async function getFlashUnstakeData(
  client: PublicClient,
  poolAddress: Address = LIQUID_STAKING_TOKEN_ADDRESS,
): Promise<IGetFlashUnstakeDataResult> {
  const contract = getLiquidStakingTokenContract(client, poolAddress);

  const [feeWei, upToAmount] = await Promise.all([
    contract.read.flashUnstakeFee(),
    contract.read.flashPool(),
  ]);

  return {
    fee: convertFromWei(feeWei, 2),
    upToAmount: convertFromWei(upToAmount),
  };
}
